/**
 * Every permission the site knows about. These strings are stored verbatim in
 * the `user_permissions` table, so renaming one requires a migration.
 */
export const PERMISSIONS = [
    'admin',
    'edit_posts',
    'read_important_dates',
    'edit_important_dates',
    'poll_participation',
    'edit_polls',
    'suggest_rule_changes',
    'edit_rules',
    'read_chats',
];
export const PERMISSION_LABELS = {
    admin: 'Administrator',
    edit_posts: 'Create / edit / delete news posts',
    read_important_dates: 'See important dates',
    edit_important_dates: 'Create / edit / delete important dates',
    poll_participation: 'Vote in polls and see poll results',
    edit_polls: 'Create / edit / delete / end polls',
    suggest_rule_changes: 'Suggest rule changes',
    edit_rules: 'Set rule-suggestion status and edit the rulebook',
    read_chats: 'Read the league chat',
};
/**
 * Granted to every user created from an invite. Anything beyond this is handed
 * out by an admin on the settings page.
 */
export const DEFAULT_MEMBER_PERMISSIONS = [
    'read_important_dates',
    'poll_participation',
    'suggest_rule_changes',
    'read_chats',
];
export function isPermission(value) {
    return PERMISSIONS.includes(value);
}
/**
 * `admin` implies every other permission, so admins never have to grant
 * themselves individual bits to administer the site.
 */
export function hasPermission(granted, required) {
    if (!granted)
        return false;
    return granted.includes('admin') || granted.includes(required);
}
//# sourceMappingURL=permissions.js.map